module.exports = __webpack_public_path__ + "static/WSC_Group_2016_Individual_Income_Tax_Return_Checklist-8f6443912c49392757a9763c4e85ec81.pdf";